import React, { useState } from 'react'
import styled from 'styled-components'
import { ShoppingCart } from '@mui/icons-material'
import { AccountCircle } from '@mui/icons-material'
import { Search } from '@mui/icons-material'
import { Menu } from '@mui/icons-material'
import { Boy } from '@mui/icons-material'
import { Girl } from '@mui/icons-material'
import { ChildCare } from '@mui/icons-material'
import { Call } from '@mui/icons-material'
import { useStateValue } from './StateProvider'
import { auth } from "../firebase";
import { useHistory } from 'react-router-dom'

function Header() {
  const [show,setShow] = useState(false)
  const [reveal,setReveal] = useState(false)
  const history = useHistory();

  const [{basket, user}, dispatch] = useStateValue();

  const checkAuth = e => {
    auth.onAuthStateChanged(authUser => {
      if (authUser) {
        dispatch({
          type: 'SET_USER',
          user: authUser,
        });
        history.push('/my-account')
      } else {
        alert("You need to create an account before you can access this part")
        history.push('/register')
      }
    })
  }

  return (
    <Container>
      <Content>
      <LogoImage>
        <a href="/home">
          <img src="https://i.ibb.co/Qfj6jZT/logo1.png" alt="logo" />
        </a>
      </LogoImage>

        <LeftMenu>
          <a href='/home'>Category</a>
          <a onClick={checkAuth}> My-Account</a>
          <a href="/contact-us"> Contact-us</a>
        </LeftMenu>

        {show?
        <PcSearch>
          <input type="search" placeholder="Search..." />
        </PcSearch>
        :null}

        <RightMenu>
          <span class="search"><Search onClick={()=>setShow(!show)} sx={{fontSize: "25px"}}/></span>
          <a href="/register" class="accounthead"> <AccountCircle sx={{fontSize: "25px"}} /> </a>
          <a href="/cart"><ShoppingCart sx={{fontSize: "25px"}} />{basket.length}</a>
          <span class="menu"><Menu onClick={()=>setReveal(!reveal)} sx={{fontSize: "25px"}}/></span>
        </RightMenu>
        </Content>

        {reveal? 
         <MobileMenu>
          <MenuTitle>
            <h3>Menu</h3>
          </MenuTitle>
          <MenuLink>
            <a href="/all-wears"><Boy sx={{fontSize: "25px"}}/><br />All-Wears</a>
            <br /><br />
            <a href="/register"><AccountCircle sx={{fontSize: "25px"}}/><br />Account</a>
            <br /><br />
            <a href="/contact-us"><Call sx={{fontSize: "25px"}}/><br />Contact-us</a>
            </MenuLink>
            <br /><br />
         </MobileMenu>
        :null}

    </Container>
  )
}

const Container = styled.header`
  width: 100vw;
  height: max-content;
  background: white;
  display: flex;
  position: fixed;
  flex-direction: column;
  border-bottom: 1px solid orange;

  @media(max-width: 768px) {
    height: 10vh;
    width: 100vw;
  }
`

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid orange;

  @media(max-width: 768px) {
    height: 100%;
  }
`;

const MobileMenu = styled.div`
  height: max-height;
  background: white;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: gray;
  color: white;
`;

const MenuTitle = styled.div`
  text-align: center;
  text-decoration: underline;
  h3 {
    font-family: sans-serif;
  }
`;

const MenuLink = styled.div`
  text-align: center;
  a {
    color: white;
    text-decoration: none;
    text-align: center;
    font-style: oblique;
    font-weight: 600;
    font-family: sans-serif;

    &:hover {
      color: orange;
    }
  }
`;

const LogoImage = styled.div`
  img {
    width: 10vw;
    margin-left: 30%;
    cursor: pointer;

    @media(max-width: 768px) {
      width: 30vw;
      height: 100%;
      min-height: 7vh;
      margin-left: 10%;
    }
    @media(width: 768px) {
      width: 20vw;
    }
  }
`

const LeftMenu = styled.div`
  cursor: pointer;

  a {
    font-size: 15px;
    word-spacing: 20px;
    font-weight: 700;
    text-decoration: none;
    color: black;

    &:hover {
      color: orange;
      font-size: 17px;
    }
  }
  @media(max-width: 768px) {
    display: none;
  }
`;

const PcSearch = styled.div`
  input {
    width: 18vw;
    height: 5vh;
    color: black;
    border-radius: 5px;
    border: 1px solid whitesmoke;

    &:hover {
      border: 1px solid orange;
    }

    @media (min-height: 1085px) {
      height: 4.8vw;
    }
  }
`;

const RightMenu = styled.div`
  width: 18vw;
  display: flex;
  justify-content: space-around;
  align-items: center;

  @media(max-width: 768px) {
    width: 25vw;
  }

  .accounthead {
    @media(max-width: 768px) {
      display: none
    }
  }

  .search {
    @media(max-width: 768px) {
      display: none;
    }
  }

  .menu {
    display: none;
    @media(max-width: 768px) {
      display: inline;
      cursor: pointer;
      &:hover {
        color: orange;
      }
    }
  }

  a, .search {
    color: black;

    &:hover {
      color: orange;
      cursor: pointer;
      font-style: oblique;
    }
  }
`;

export default Header